import { createAuthContext } from '@react-keycloak/core';
import { isServer } from './utils';
// Context to hold Keycloak and his state
export var reactKeycloakSsrContext = createAuthContext({
    initialized: isServer(),
});
export var ReactKeycloakSSRContextConsumer = reactKeycloakSsrContext.Consumer;
//# sourceMappingURL=context.js.map